import { render, staticRenderFns } from "./AddRedirectDialog.vue?vue&type=template&id=34fc5eff&scoped=true&"
import script from "./AddRedirectDialog.vue?vue&type=script&lang=ts&"
export * from "./AddRedirectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc5eff",
  null
  
)

export default component.exports